// extracted by mini-css-extract-plugin
export default {"icon__btn":"IconButton_icon__btn__y3FsG"};